import { type StartEditingEvent } from '../events/types.ts';
import { type SelectionState } from '../state/types.ts';

import { type ReducerResponse, type SelectionReducerPolicies } from './types.ts';

/**
 * Requests editor ownership for the focused table cell or explicit panel cell.
 * Policy rejection and missing focus are normal noops, preventing machine/UI
 * disagreement when editing is unavailable.
 */
export function requestCellEditReducer(
  state: SelectionState,
  event: StartEditingEvent,
  policies: SelectionReducerPolicies
): ReducerResponse {
  const editingContext = event.editingContext ?? 'table';
  const cell = editingContext === 'panel' ? event.cell : state.focusedCell;

  if (!cell) {
    return { next: state, delta: { kind: 'noop' } };
  }

  if (!policies.canRequestCellEdit(cell, editingContext)) {
    return { next: state, delta: { kind: 'noop' } };
  }

  return {
    next: {
      ...state,
      activeEdit: {
        position: cell,
        editingContext
      }
    },
    delta: {
      kind: 'cellEditRequested',
      position: cell,
      source: event.source,
      editingContext,
      initialKey: event.initialKey
    }
  };
}
